// extracted by mini-css-extract-plugin
export var pageColumns = "ContentfulBlockColumns-module--pageColumns--7Akhe";
export var column = "ContentfulBlockColumns-module--column--hnQk4";